import { render, staticRenderFns } from "./search.vue?vue&type=template&id=82f81aec&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f81aec')) {
      api.createRecord('82f81aec', component.options)
    } else {
      api.reload('82f81aec', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=82f81aec&", function () {
      api.rerender('82f81aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/iframe/search.vue"
export default component.exports